import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import AuthSignInPage from '@/pages/auth/AuthSignInPage';

const searchSchema = z.object({
  returnUrl: z.string().optional(),
});

export const Route = createFileRoute('/_auth/auth/sign-in')({
  validateSearch: searchSchema,
  component: AuthSignInPage,
});
